module.exports = __webpack_public_path__ + "static/media/Circo2025_02.c8d8e209.webp";